import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import webPage from "./modules/webPage";
import region from "./modules/region";
import getters from "./getters";
// import device from "./modules/device";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    webPage,
    region,
    // device,
  },
  getters,
});

export default store;
